import { useEffect } from "react";
// mine
import { GameManager } from "@/app/lib/game-state/game-manager";

export function useTheme(gameManager: GameManager) {
    useEffect(() => {
        const theme = gameManager.activeMode === 'story' ? 'story' : 'pyramid';
        if (theme) {
            document.documentElement.setAttribute('data-theme', theme);
        } else {
            document.documentElement.removeAttribute('data-theme');
        }
    }, [gameManager.activeMode]);
}